/**
 * Is Lighthouse
 */
export function isLightHouse(userAgent) {
    // return userAgent?.includes('Chrome-Lighthouse')
    return false;
}
